import { H2, YStack } from 'tamagui';
import { TrainingStatsContent } from '@mrrmlab/feature-lists';

export function EinstellungenTrainingRoute() {
  return (
    <YStack padding="$4" gap="$3" maxWidth={640}>
      <H2>OCR-Training</H2>
      <TrainingStatsContent />
    </YStack>
  );
}
